module.exports = __webpack_public_path__ + "static/media/hands-usd.ee912c29.svg";